import React from 'react';
import { Link } from 'react-router-dom';
import logo from 'assets/logo.png';
import classes from 'styles/Footer.module.scss';
import MediumImage from 'assets/FinalLandingPage/MediumIcon.png';
import TwitterImage from 'assets/FinalLandingPage/TwitterIcon.png';
import LinkedinImage from 'assets/FinalLandingPage/LinkedinIcon.png';

function Footer() {
  return (
    <>
      <div className={classes.container_fourteen}>
        <div className={classes.footerContent}>
          <Link className={classes.logoSection} to="/">
            <img src={logo} alt="Logo" className={classes.logo} />
          </Link>
          <div className={classes.navigationLinks}>
            <Link to="/termsCondition" className={classes.mainlink}>
              Terms &amp; Conditions
            </Link>
            <Link to="/privacy" className={classes.mainlink}>
              Privacy Policy
            </Link>
            <Link to="/useragreement" className={classes.mainlink}>
              User Agreement
            </Link>
            <Link to="/riskdisclosure" className={classes.mainlink}>
              Risk Disclosure
            </Link>
            <Link to="/publicdisclosure" className={classes.mainlink}>
              Public Disclosure
            </Link>
            <Link to="/complianthandling" className={classes.mainlink}>
              Complaints Handling
            </Link>
          </div>
          <div className={classes.socialLinks}>
            <a
              target="_blank"
              href="https://medium.com/@Encryptus"
              rel="noreferrer"
              className={classes.socialIcon}
            >
              <img src={MediumImage} alt="MediumIcon" />
            </a>
            <a
              target="_blank"
              href="https://twitter.com/EncryptusGlobal"
              rel="noreferrer"
              className={classes.socialIcon}
            >
              <img src={TwitterImage} alt="TwitterIcon" />
            </a>
            <a
              target="_blank"
              href="https://www.linkedin.com/company/encryptus/?viewAsMember=true"
              rel="noreferrer"
              className={classes.socialIcon}
            >
              <img src={LinkedinImage} alt="LinkedinIcon" />
            </a>
          </div>
        </div>
      </div>
    </>
  );
}

export default Footer;
